import { ShieldCheck } from "lucide-react";
import type { ReactNode } from "react";

export const HELD_FUNDS_EXPLAINER =
  "Want To Buy is a connection platform — it does not process payments or hold funds. Buyers and sellers arrange payment directly, and PayPal Goods & Services is strongly recommended because PayPal provides independent buyer and seller protection.";

/**
 * Inline info dot describing the connection-only payment model.
 * Kept as a lightweight component so existing call sites continue to render
 * without layout regressions.
 */
export function HeldFundsInfo({ className = "", label }: { className?: string; label?: ReactNode }) {
  return (
    <span
      tabIndex={0}
      title={HELD_FUNDS_EXPLAINER}
      aria-label="About peer-to-peer payments"
      className={`group relative inline-flex items-center align-middle text-muted-foreground hover:text-primary focus:outline-none focus:text-primary ${className}`}
    >
      {label}
      <ShieldCheck className="ml-1 h-3.5 w-3.5" />
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 top-full z-50 mt-2 w-72 -translate-x-1/2 rounded-md border border-border bg-panel p-3 text-left text-xs text-foreground opacity-0 shadow-2xl transition group-hover:opacity-100 group-focus:opacity-100"
      >
        {HELD_FUNDS_EXPLAINER}
      </span>
    </span>
  );
}
